import type { AxiosRequestConfig } from 'axios'

export function buildTenantHeaderConfig(tenantId?: string | null): AxiosRequestConfig {
  return tenantId ? { headers: { 'X-Tenant-Id': tenantId } } : {}
}
